export const QUICK_REPLY_NOTIFICATIONS = {
    CREATED: 'Quick Reply Created!',
    DELETED: 'Quick Reply Deleted!',
    SAVED: 'Quick Reply Saved!',
  };
